import { render, staticRenderFns } from "./adder.vue?vue&type=template&id=ce64f202&scoped=true"
import script from "./adder.vue?vue&type=script&lang=js"
export * from "./adder.vue?vue&type=script&lang=js"
import style0 from "./adder.vue?vue&type=style&index=0&id=ce64f202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce64f202",
  null
  
)

export default component.exports